import { createContext, useContext } from "react";

const Ctx = createContext(1);

export const ScaleFactorProvider = Ctx.Provider;
export const useScaleFactor = () => useContext(Ctx);
